{
  "version": 1,
  "asset_id": "0538c578-e374-45c3-914f-b807be4aa0c7",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/0538c578-e374-45c3-914f-b807be4aa0c7/warmtepomp-1280.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/0538c578-e374-45c3-914f-b807be4aa0c7/warmtepomp-1280.avif",
  "original_filename": "warmtepomp-1280.avif",
  "size": 30293,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:42Z"
}
